export * from './IconImageFile';
export { default as IconImageFile } from './IconImageFile';
